"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = exports.NoRetryError = exports.InvalidInputError = exports.NotImplementedError = void 0;
const json_1 = require("./json");
class NotImplementedError extends Error {
    constructor(message) {
        super(message);
        this.name = NotImplementedError.name;
    }
}
exports.NotImplementedError = NotImplementedError;
class InvalidInputError extends Error {
    constructor(message) {
        super(message);
        this.name = InvalidInputError.name;
    }
}
exports.InvalidInputError = InvalidInputError;
class NoRetryError extends Error {
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
exports.NoRetryError = NoRetryError;
const getErrorMessage = (error, withStack = true) => {
    let errorMsg = `${error}`;
    if (error instanceof Error) {
        errorMsg =
            error.message +
                (withStack ? (error.stack ? '\n' + error.stack : '') : '');
    }
    else if (!(error instanceof String)) {
        errorMsg = json_1.toJson(error);
    }
    return errorMsg;
};
exports.getErrorMessage = getErrorMessage;
